import React from 'react';
import { HeadingWithBody, TileSelect } from '@99designs/spa-common';
import { svgBase64ToAscii } from '../../utils/svgBase64ToAscii';
import { STEP_BRANDING_STAGE } from '../constants';
import brandingStageExistingSvg from './branding-stage-existing.svg';
import brandingStageNewSvg from './branding-stage-new.svg';
import type { StepComponentProps } from '../../components/Onboarder/Config';
import type { SelectedValues } from '../config';

export type BrandingStageValue = 'new' | 'existing';

export function BrandingStageStepInputs({ data, onChange }: StepComponentProps<SelectedValues>) {
    return (
        <TileSelect<BrandingStageValue>
            name={STEP_BRANDING_STAGE}
            value={data[STEP_BRANDING_STAGE]}
            options={[
                {
                    label: (
                        <HeadingWithBody
                            heading={__('I want to create new branding')}
                            body={__('from scratch')}
                        />
                    ),
                    value: 'new',
                    icon: svgBase64ToAscii(brandingStageNewSvg),
                },
                {
                    label: (
                        <HeadingWithBody
                            heading={__('I have existing branding')}
                            body={__('that I would like to update or extend')}
                        />
                    ),
                    value: 'existing',
                    icon: svgBase64ToAscii(brandingStageExistingSvg),
                },
            ]}
            onChange={(value: BrandingStageValue, name: string) => {
                const newData: SelectedValues = {
                    ...data,
                    [name]: value,
                };
                onChange(newData);
            }}
        />
    );
}
